import { useInsertionEffect, useRef } from "react";

/**
 * A ref that holds the latest committed value, for event-time callbacks that
 * must not re-create on every render. Not for reads during render.
 */
export const useLatestRef = <T>(value: T) => {
    const ref = useRef(value);
    // Insertion effects run before every layout effect in the commit
    // (children's included), so layout effects and callback refs see the fresh value.
    useInsertionEffect(() => {
        ref.current = value;
    });
    return ref;
};
